<template>
  <button id="razorpay-button" @click="getRazorPayorder($event)" :style="getClass">{{text}}</button>
</template>

<script>
  import notification from '@/services/notificationService';
  import { mapGetters } from 'vuex';
  import paymentService from '@/services/paymentService';

  export default {
    name: 'Razorpay',
    props: {
      config: {
        type: Object,
        required: true,
      },
      text: {
        type: String,
        required: false,
        default: 'Razorpay',
      },

      cls: {
        type: Object || String,
        required: false,
      },

      total: {
        type: Number,
        required: true,
      },
    },

    data() {
      return {
        mainClass: null,
        order: null
      };
    },

    created() {
      this.mainClass = {
        padding: '0.5rem 2rem',
        background: '#773292',
        color: 'white',
        border: 'none',
        'margin-top': '2rem',
      };

    },

    methods: {
      
      async getRazorPayorder(ev) {
        ev.preventDefault();
        const amountObj = this.$store.getters['cartStore/getTotal'];
        console.log(amountObj);
        if(amountObj) {
          let amount = amountObj.amount;
          const randomNumber = Math.floor(Math.random() * 99);
          if (!Number.isInteger(amountObj.amount)) {
            const amountAsString = (amountObj.amount + '').split('.');
            amount = ((+amountAsString[0]) * 100) + (amountAsString[1].length === 1 ? ((+amountAsString[1]) * 10) : ((+amountAsString[1])));
          } else {
            amount = amount * 100;
          }
          const razorpayOrder = await this.$store.dispatch('cartStore/createRazorpayOrder', {
            amount: amount,
            currency: amountObj.currency,
            receipt: "order_rcptid_" + randomNumber,
            checkoutId: this.checkoutId
          });
          if(razorpayOrder.responseData && razorpayOrder.responseData.razorPayOrder) {
            this.order = razorpayOrder.responseData.order;
            this.initiateRazorpay(razorpayOrder.responseData.razorPayOrder);
          } else {
            notification.error(this, 'payment failed');
            this.$router.push('/orders');
          }
        }
      },

      initiateRazorpay(order) {
        if(order) {
          const amount = (+order.amount);
          const rzp1 = new Razorpay({
            key: process.env.RAZORPAY_KEY_ID,
            amount: amount,
            name: "Bestech solutions pvt ltd",
            description: "Test Transaction",
            currency: order.currency,
            image: process.env.RAZORPAY_IMAGE,
            handler: (e) => {
              if(e.razorpay_payment_id) {
                this.handlePayment(e);
              } else {
                console.log(e);
                notification.error(this, 'payment failed');
                this.$router.push('/orders');
              }
            },
            prefill: {
              name: "Prasad Nidode",
              email: "Prasad.nidode@gmail.com",
              contact: "9164445661"
            },
            notes: {
              address: "asdasdsa"
            },
            theme: {
              color: "#00ffff"
            },
            order_id: order.id,
            // callback_url: "http://localhost:5201/#/checkout/order_IL2RXB8Iy9nYp6",
            redirect: false
          });
          rzp1.open();  
        }
      },
    
      async handlePayment(data) {
        console.log(data, this.order);
        if(data && this.order && this.order._id) {
          try {
            const response = await paymentService.payWithRazorpay(data, this.order._id);
            this.$store.commit('cartStore/resetOrders');
            this.$router.push(`/orders/${this.order._id}`);
            notification.success(this, 'Payment was successful.');
          } catch (error) {
            console.log(error);
            const msg = error.httpStatus ? '' : error;
            notification.error(this, `Error: ${msg}`, 'all');
          }
        }
      },
    },
  
    computed: {
      getClass() {
        return this.mainClass;
      },
      ...mapGetters({
        checkoutId: 'cartStore/checkoutId',
        shippingMethod: 'shippingStore/shippingMethod'
      }),
    },
  };
</script>

<style lang="scss">
#khalti-entry {
}
</style>
